import script from "./PopupProvince.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupProvince.vue?vue&type=script&setup=true&lang=js"

import "./PopupProvince.vue?vue&type=style&index=0&id=0d373ae7&scoped=true&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\WWW\\qianpaiyun\\v2_2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d373ae7"]])

export default __exports__